import { render, staticRenderFns } from "./last.vue?vue&type=template&id=677fd003&scoped=true&"
import script from "./last.vue?vue&type=script&lang=js&"
export * from "./last.vue?vue&type=script&lang=js&"
import style0 from "./last.vue?vue&type=style&index=0&id=677fd003&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677fd003",
  null
  
)

export default component.exports